import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import styles from "./footer.module.scss";
import { Link, useLocation } from "react-router-dom";
import LinkAccountPop from "../Modals/LinkAccountPop";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../../hooks/useLanguage";

const Footer = () => {
  // const { t } = useTranslation();
  const t = useLanguage();

  const { user } = useSelector(({ Auth }) => ({
    user: Auth.user,
  }));
  const [linkAccount, setLinkAccount] = useState();
  const location = useLocation();
  // const handleLinkAccount = () => {
  //   setLinkAccount(!linkAccount);
  // };
  //console.info(user?.unreadTaskCount,"COUNTTT")
  return (
    <>
      {linkAccount && (
        <LinkAccountPop
          linkAccount={linkAccount}
          setLinkAccount={setLinkAccount}
          isProfileSection={true}
        />
      )}

      <footer
        className="siteFooter"
        style={{ bottom: 0, left: 0, right: 0, zIndex: 999 }}
      >
        <Container>
          <Row>
            <Col lg="12">
              <div
                className={`${styles.innerWrp} inner d-flex p-3 align-items-center gap-10 justify-content-between`}
              >
                <Link
                  to={"/game"}
                  className={`${styles.link} ${
                    location.pathname === "/game" && styles.active
                  } link text-white text-center fw-sbold text-uppercase position-relative`}
                >
                  <span className="icn d-block mb-1">{game}</span>
                  {t("footer.game")}
                </Link>
                <Link
                  to={"/task"}
                  className={`${styles.link} ${
                    location.pathname === "/task" && styles.active
                  } link text-white text-center fw-sbold text-uppercase position-relative`}
                >
                  {user?.unreadTaskCount &&
                  (Number(user?.unreadTaskCount) > 0 ||
                    user?.unreadTaskCount === "9+") ? (
                    <span
                      className="rounded-circle bg-danger d-flex align-items-center justify-content-center text-white position-absolute"
                      style={{
                        height: 15,
                        width: 15,
                        fontSize: 7,
                        top: -3,
                        paddingTop: 3,
                        right: -7,
                        background: "#ff0b0b",
                        zIndex: 9,
                      }}
                    >
                      {user?.unreadTaskCount}
                    </span>
                  ) : null}
                  <span className="icn d-block mb-1">{task}</span>
                  {t("footer.task")}
                </Link>

                {/* <Link
                  to={"/roadmap"}
                  className={`${styles.link} ${location.pathname === "/roadmap" && styles.active
                    } link text-white text-center fw-sbold text-uppercase position-relative`}
                >
                  <span className="icn d-block mb-1">{roadMap}</span>
                  Map
                </Link> */}
                <Link
                  to={"/shop"}
                  className={`${styles.link} ${
                    location.pathname === "/shop" && styles.active
                  } link text-white text-center fw-sbold text-uppercase position-relative`}
                >
                  <span className={`${styles.icnBuy} icn d-block mb-1`}>
                    {shop}
                  </span>
                  {t("footer.buy")}
                </Link>
                <Link
                  to={"/wallet"}
                  className={`${styles.link} ${
                    location.pathname === "/wallet" && styles.active
                  } link text-white text-center fw-sbold text-uppercase position-relative`}
                >
                  <span className="icn d-block mb-1">{wallet}</span>
                  {t("footer.wallet")}
                </Link>
                <Link
                  to={"/friends"}
                  className={`${styles.link} ${
                    location.pathname === "/friends" && styles.active
                  } link text-white text-center fw-sbold text-uppercase position-relative`}
                >
                  <span className="icn d-block mb-1">{friends}</span>
                  {t("footer.friends")}
                </Link>
                {/* <Button
                  variant="transparent"
                  onClick={handleLinkAccount}
                  // to={""}
                  className={`${styles.link} ${location.pathname == "/profile" && styles.active
                    } link text-white text-center fw-sbold text-uppercase position-relative border-0 p-0`}
                >
                  <span className="icn d-block mb-1">{profile}</span>
                  Profile
                </Button> */}
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </>
  );
};

export default Footer;

const game = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="26"
    viewBox="0 0 29 27"
    fill="none"
  >
    <path
      d="M9.54737 18.5807C9.54737 19.1235 9.9879 19.5641 10.5307 19.5641C11.0735 19.5641 11.514 19.1235 11.514 18.5807V17.2195H12.9225C13.4653 17.2195 13.9058 16.779 13.9058 16.2362C13.9058 15.6934 13.4653 15.2529 12.9225 15.2529H11.514V13.8935C11.514 13.3507 11.0735 12.9102 10.5307 12.9102C9.9879 12.9102 9.54737 13.3507 9.54737 13.8935V15.2529H8.13959C7.59678 15.2529 7.15625 15.6934 7.15625 16.2362C7.15625 16.779 7.59678 17.2195 8.13959 17.2195H9.54737V18.5807Z"
      fill="currentColor"
    />
    <path
      d="M18.6893 15.0194H18.5556C18.0128 15.0194 17.5723 14.5789 17.5723 14.0361C17.5723 13.4933 18.0128 13.0527 18.5556 13.0527H18.6893C19.2321 13.0527 19.6727 13.4933 19.6727 14.0361C19.6727 14.5789 19.2321 15.0194 18.6893 15.0194Z"
      fill="currentColor"
    />
    <path
      d="M20.8232 19.493H20.9582C21.501 19.493 21.9416 19.0525 21.9416 18.5097C21.9416 17.9669 21.501 17.5264 20.9582 17.5264H20.8232C20.2804 17.5264 19.8398 17.9669 19.8398 18.5097C19.8398 19.0525 20.2804 19.493 20.8232 19.493Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.2587 5.59253C4.45525 5.63333 0.974609 8.45045 0.974609 16.2961C0.974609 24.1981 4.50675 27 14.4765 27C24.4449 27 27.9783 24.1981 27.9783 16.2961C27.9783 8.87353 24.8618 5.95179 16.2254 5.62371V5.24183C16.1978 3.26074 14.5419 1.68871 12.5936 1.67823H11.2628C11.239 1.67201 11.2131 1.66594 11.1858 1.65953C11.0462 1.62679 10.8705 1.58556 10.7554 1.47369C10.6203 1.34127 10.5443 1.16427 10.543 0.975469C10.539 0.433979 10.0998 0 9.55963 0H9.55176C9.00896 0.00393334 8.57236 0.448401 8.57629 0.991202C8.58154 1.70707 8.86736 2.37705 9.37869 2.87921C9.89003 3.37874 10.5351 3.62392 11.2719 3.6449H12.6014C13.5114 3.62261 14.2469 4.36601 14.2587 5.25495V5.59253ZM2.94128 16.2961C2.94128 9.60016 5.63562 7.55876 14.4765 7.55876C23.316 7.55876 26.0116 9.60016 26.0116 16.2961C26.0116 22.9919 23.316 25.0333 14.4765 25.0333C5.63562 25.0333 2.94128 22.9919 2.94128 16.2961Z"
      fill="currentColor"
    />
  </svg>
);

const friends = (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.2616 1.34174H7.57967C4.35781 1.34174 1.74597 3.95357 1.74597 7.17543V19.8574C1.74597 23.0792 4.35781 25.6911 7.57967 25.6911H20.2616C23.4835 25.6911 26.0953 23.0792 26.0953 19.8574V7.17543C26.0953 3.95357 23.4835 1.34174 20.2616 1.34174Z"
      stroke="currentColor"
      stroke-width="1.85715"
    />
    <g opacity="1">
      <path
        d="M12.0074 18.0667V18.0667C11.6529 19.0212 12.3588 20.0365 13.377 20.0365H19.8026C20.3337 20.0365 20.5993 20.0365 20.7968 20.0037C22.1426 19.78 23.0391 18.4906 22.7803 17.1511C22.7423 16.9545 22.6498 16.7056 22.4649 16.2077V16.2077C22.3109 15.7932 22.234 15.586 22.1445 15.4051C21.554 14.212 20.3932 13.4048 19.0691 13.2668C18.8684 13.2458 18.6473 13.2458 18.2052 13.2458H16.4731C16.2664 13.2458 16.1631 13.2458 16.0604 13.2513C15.8019 13.265 15.5455 13.3045 15.2949 13.3693C15.1953 13.395 15.0968 13.4261 14.8998 13.4884V13.4884M10.3833 8.88039C9.31178 8.88039 8.44313 8.01174 8.44313 6.9402C8.44313 5.86866 9.31178 5 10.3833 5C11.4549 5 12.3235 5.86866 12.3235 6.9402C12.3235 8.01174 11.4549 8.88039 10.3833 8.88039ZM17.6591 10.8206C16.5875 10.8206 15.7189 9.95194 15.7189 8.88039C15.7189 7.80885 16.5875 6.9402 17.6591 6.9402C18.7306 6.9402 19.5993 7.80885 19.5993 8.88039C19.5993 9.95194 18.7306 10.8206 17.6591 10.8206ZM8.08444 18.0963H12.5268C13.058 18.0963 13.3235 18.0963 13.521 18.0635C14.8669 17.8398 15.7634 16.5504 15.5045 15.2109C15.4665 15.0143 15.3741 14.7654 15.1891 14.2675V14.2675C15.0352 13.853 14.9582 13.6458 14.8687 13.4649C14.2783 12.2718 13.1174 11.4646 11.7934 11.3266C11.5927 11.3056 11.3716 11.3056 10.9295 11.3056H9.6818C9.23967 11.3056 9.01861 11.3056 8.81792 11.3266C7.49386 11.4646 6.33301 12.2718 5.74256 13.4649C5.65306 13.6458 5.57609 13.853 5.42214 14.2675V14.2675C5.23721 14.7654 5.14475 15.0143 5.10676 15.2109C4.84788 16.5504 5.74442 17.8398 7.09025 18.0635C7.28774 18.0963 7.55331 18.0963 8.08444 18.0963Z"
        stroke="currentColor"
        stroke-width="1.45515"
        stroke-linejoin="round"
      />
    </g>
  </svg>
);

const task = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="26"
    viewBox="0 0 26 25"
    fill="none"
  >
    <path
      d="M19.6282 9.5384H13.6457C13.1785 9.5384 12.791 9.15096 12.791 8.68375C12.791 8.21654 13.1785 7.8291 13.6457 7.8291H19.6282C20.0954 7.8291 20.4829 8.21654 20.4829 8.68375C20.4829 9.15096 20.1068 9.5384 19.6282 9.5384Z"
      fill="currentColor"
    />
    <path
      d="M7.66348 10.4042C7.44697 10.4042 7.23046 10.3245 7.05953 10.1535L6.20488 9.29885C5.87441 8.96838 5.87441 8.42141 6.20488 8.09094C6.53535 7.76048 7.08232 7.76048 7.41279 8.09094L7.66348 8.34164L9.62348 6.38164C9.95395 6.05117 10.5009 6.05117 10.8314 6.38164C11.1619 6.7121 11.1619 7.25908 10.8314 7.58954L8.26744 10.1535C8.1079 10.3131 7.89139 10.4042 7.66348 10.4042Z"
      fill="currentColor"
    />
    <path
      d="M19.6282 17.515H13.6457C13.1785 17.515 12.791 17.1275 12.791 16.6603C12.791 16.1931 13.1785 15.8057 13.6457 15.8057H19.6282C20.0954 15.8057 20.4829 16.1931 20.4829 16.6603C20.4829 17.1275 20.1068 17.515 19.6282 17.515Z"
      fill="currentColor"
    />
    <path
      d="M7.66348 18.3808C7.44697 18.3808 7.23046 18.301 7.05953 18.1301L6.20488 17.2754C5.87441 16.9449 5.87441 16.398 6.20488 16.0675C6.53535 15.737 7.08232 15.737 7.41279 16.0675L7.66348 16.3182L9.62348 14.3582C9.95395 14.0277 10.5009 14.0277 10.8314 14.3582C11.1619 14.6887 11.1619 15.2356 10.8314 15.5661L8.26744 18.1301C8.1079 18.2896 7.89139 18.3808 7.66348 18.3808Z"
      fill="currentColor"
    />
    <path
      d="M16.6432 24.5H9.80601C3.61833 24.5 0.974609 21.8563 0.974609 15.6686V8.8314C0.974609 2.64372 3.61833 0 9.80601 0H16.6432C22.8309 0 25.4746 2.64372 25.4746 8.8314V15.6686C25.4746 21.8563 22.8309 24.5 16.6432 24.5ZM9.80601 1.7093C4.55275 1.7093 2.68391 3.57814 2.68391 8.8314V15.6686C2.68391 20.9219 4.55275 22.7907 9.80601 22.7907H16.6432C21.8965 22.7907 23.7653 20.9219 23.7653 15.6686V8.8314C23.7653 3.57814 21.8965 1.7093 16.6432 1.7093H9.80601Z"
      fill="currentColor"
    />
  </svg>
);

const wallet = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="26"
    viewBox="0 0 29 28"
    fill="none"
  >
    <path
      d="M17.702 19.2979H11.2437C10.7141 19.2979 10.2749 18.8587 10.2749 18.3291C10.2749 17.7995 10.7141 17.3604 11.2437 17.3604H17.702C18.2316 17.3604 18.6707 17.7995 18.6707 18.3291C18.6707 18.8587 18.2316 19.2979 17.702 19.2979Z"
      fill="currentColor"
    />
    <path
      d="M14.4714 22.6046C13.9419 22.6046 13.5027 22.1654 13.5027 21.6358V15.1775C13.5027 14.6479 13.9419 14.2087 14.4714 14.2087C15.001 14.2087 15.4402 14.6479 15.4402 15.1775V21.6358C15.4402 22.1654 15.001 22.6046 14.4714 22.6046Z"
      fill="currentColor"
    />
    <path
      d="M5.68828 11.8961C5.44286 11.8961 5.19745 11.7927 5.0037 11.6119C4.73245 11.3406 4.64203 10.9144 4.79703 10.5528L7.19953 4.81776C7.2512 4.70151 7.27703 4.62401 7.31578 4.55942C9.22745 0.15484 11.6687 -0.917242 15.9828 0.736091C16.2282 0.826507 16.422 1.02026 16.5253 1.26567C16.6287 1.51109 16.6287 1.78234 16.5253 2.02776L12.7407 10.8111C12.5857 11.1598 12.237 11.3923 11.8495 11.3923H8.16828C7.43203 11.3923 6.73453 11.5344 6.06286 11.8186C5.94661 11.8702 5.81745 11.8961 5.68828 11.8961ZM12.6762 1.93734C11.0745 1.93734 10.0929 2.98359 9.07245 5.36026C9.05953 5.39901 9.0337 5.43776 9.02078 5.47651L7.3287 9.49359C7.61286 9.46776 7.88411 9.45484 8.16828 9.45484H11.2037L14.3166 2.22151C13.7095 2.02776 13.167 1.93734 12.6762 1.93734Z"
      fill="currentColor"
    />
    <path
      d="M22.5974 11.6504C22.507 11.6504 22.4037 11.6375 22.3132 11.6117C21.8353 11.4696 21.3057 11.3921 20.7632 11.3921H11.8507C11.5278 11.3921 11.2178 11.2242 11.037 10.9529C10.869 10.6817 10.8303 10.3329 10.9595 10.0359L14.7053 1.34294C14.8991 0.877937 15.4674 0.567937 15.9453 0.722937C16.1003 0.774604 16.2424 0.839187 16.3974 0.903771L19.4457 2.18252C21.2282 2.91877 22.4166 3.69377 23.1916 4.62377C23.3466 4.8046 23.4757 4.99835 23.592 5.1921C23.7341 5.41169 23.8632 5.68294 23.9537 5.95419C23.9924 6.0446 24.057 6.21252 24.0957 6.39335C24.4574 7.60752 24.2766 9.11877 23.5016 11.0563C23.3466 11.4179 22.9849 11.6504 22.5974 11.6504ZM13.3232 9.4546H20.7762C21.1895 9.4546 21.5899 9.49335 21.9903 9.55794C22.352 8.43419 22.4295 7.56877 22.2228 6.87127C22.197 6.75502 22.1712 6.70335 22.1582 6.65169C22.0807 6.44502 22.0291 6.32877 21.9645 6.22544C21.8741 6.08335 21.8095 5.9671 21.7062 5.85085C21.1507 5.17919 20.1691 4.55919 18.7095 3.96502L16.152 2.89294L13.3232 9.4546Z"
      fill="currentColor"
    />
    <path
      d="M19.5089 27.7705H9.43393C9.07227 27.7705 8.73644 27.7446 8.4006 27.7059C3.86685 27.3959 1.28352 24.8125 0.973519 20.2271C0.934769 19.943 0.908936 19.5942 0.908936 19.2455V16.7267C0.908936 13.8205 2.63977 11.1983 5.31352 10.0358C6.21769 9.64834 7.18644 9.45459 8.18102 9.45459H20.7877C21.5239 9.45459 22.2344 9.55792 22.8931 9.76459C25.9285 10.6817 28.0598 13.5492 28.0598 16.7267V19.2455C28.0598 19.5296 28.0469 19.8009 28.0339 20.0592C27.7498 25.1096 24.8048 27.7705 19.5089 27.7705ZM8.1681 11.3921C7.43185 11.3921 6.73435 11.5342 6.06269 11.8184C4.09935 12.6709 2.83352 14.5955 2.83352 16.7267V19.2455C2.83352 19.5167 2.85935 19.788 2.88519 20.0463C3.1306 23.7275 4.93894 25.5359 8.56852 25.7813C8.89144 25.82 9.14977 25.8459 9.42102 25.8459H19.496C23.7585 25.8459 25.851 23.973 26.0577 19.9688C26.0706 19.7363 26.0835 19.5038 26.0835 19.2455V16.7267C26.0835 14.3888 24.5206 12.2963 22.2989 11.6117C21.821 11.4696 21.2914 11.3921 20.7489 11.3921H8.1681Z"
      fill="currentColor"
    />
    <path
      d="M1.86523 17.6958C1.33565 17.6958 0.896484 17.2567 0.896484 16.7271V12.9425C0.896484 8.87382 3.7769 5.36049 7.75523 4.58549C8.10398 4.5209 8.46565 4.65006 8.69815 4.92131C8.91773 5.19256 8.98232 5.58007 8.84023 5.90299L6.57982 11.3021C6.47648 11.5346 6.29565 11.7154 6.07607 11.8188C4.11273 12.6713 2.8469 14.5958 2.8469 16.7271C2.83398 17.2567 2.40773 17.6958 1.86523 17.6958ZM6.20523 7.19465C4.5519 8.12465 3.35065 9.75215 2.97607 11.6508C3.5444 11.0697 4.20315 10.5788 4.95232 10.2171L6.20523 7.19465Z"
      fill="currentColor"
    />
    <path
      d="M27.0782 17.6951C26.5486 17.6951 26.1094 17.2559 26.1094 16.7264C26.1094 14.3884 24.5465 12.2959 22.3248 11.6114C22.0665 11.5339 21.8469 11.353 21.7307 11.1076C21.6144 10.8622 21.6015 10.5781 21.7048 10.3326C22.3119 8.82139 22.4669 7.72347 22.2215 6.87097C22.1957 6.75472 22.1698 6.70306 22.1569 6.65139C21.989 6.27681 22.0794 5.83764 22.3765 5.55347C22.6736 5.26931 23.1257 5.20472 23.4873 5.39847C26.3032 6.87097 28.0469 9.76431 28.0469 12.9418V16.7264C28.0469 17.2559 27.6077 17.6951 27.0782 17.6951ZM23.8361 10.126C24.6498 10.5006 25.3732 11.0301 25.9802 11.663C25.7348 10.3972 25.1277 9.24764 24.2365 8.34347C24.1719 8.88597 24.0427 9.48014 23.8361 10.126Z"
      fill="currentColor"
    />
  </svg>
);

// const roadMap = (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     width="26"
//     height="26"
//     viewBox="0 0 27 26"
//     fill="none"
//   >
//     <path
//       d="M9.99482 14.5729C9.23357 14.5729 8.47231 14.295 7.86814 13.7271C5.94689 11.9025 5.17359 9.89676 5.63276 7.93926C6.09192 5.93342 7.84398 4.58008 9.99482 4.58008C12.1456 4.58008 13.8978 5.93342 14.357 7.93926C14.8041 9.90884 14.0306 11.9025 12.1094 13.7271C11.5173 14.2829 10.7561 14.5729 9.99482 14.5729ZM7.39691 8.33799C7.01025 9.98133 8.1219 11.4556 9.12482 12.4101C9.62023 12.8813 10.3815 12.8813 10.8648 12.4101C11.8556 11.4676 12.9673 9.99341 12.5927 8.33799C12.2664 6.90008 10.9857 6.38049 9.99482 6.38049C9.00398 6.38049 7.73525 6.90008 7.39691 8.33799Z"
//       fill="currentColor"
//     />
//     <path
//       d="M10.0306 9.95671C9.36602 9.95671 8.82227 9.41296 8.82227 8.74837C8.82227 8.08379 9.35393 7.54004 10.0306 7.54004H10.0427C10.7073 7.54004 11.251 8.08379 11.251 8.74837C11.251 9.41296 10.6952 9.95671 10.0306 9.95671Z"
//       fill="currentColor"
//     />
//     <path
//       d="M23.6012 24.022C23.3595 24.022 23.1299 23.9253 22.9607 23.7562L15.2516 16.047C14.9012 15.6966 14.9012 15.1166 15.2516 14.7662L24.5921 5.42575C24.8217 5.19617 25.172 5.11159 25.4862 5.19617C25.8003 5.29284 26.042 5.54659 26.1145 5.86075C26.3441 6.88784 26.4649 8.03575 26.4649 9.36492V16.6149C26.4649 19.962 25.7641 22.2216 24.2416 23.7562C24.0724 23.9253 23.8187 23.9616 23.6012 24.022ZM17.1728 15.4066L23.5287 21.7624C24.2899 20.5903 24.6524 18.9228 24.6524 16.6149V9.36492C24.6524 8.8695 24.6403 8.41034 24.6041 7.97534L17.1728 15.4066Z"
//       fill="currentColor"
//     />
//     <path
//       d="M6.55215 25.6529C6.47965 25.6529 6.41926 25.6408 6.34676 25.6287C2.34717 24.7104 0.486328 21.8467 0.486328 16.6146V9.36458C0.486328 2.80333 3.28966 0 9.85091 0H17.1009C22.333 0 25.1967 1.86085 26.1151 5.86043C26.1876 6.16251 26.0909 6.48875 25.8734 6.70625L7.19257 25.3871C7.0234 25.5563 6.79382 25.6529 6.55215 25.6529ZM9.85091 1.8125C4.28049 1.8125 2.29883 3.79417 2.29883 9.36458V16.6146C2.29883 20.8075 3.45884 22.91 6.27426 23.7437L24.218 5.8C23.3963 2.98458 21.2817 1.82457 17.0888 1.82457H9.85091V1.8125Z"
//       fill="currentColor"
//     />
//     <path
//       d="M17.0991 25.9793H9.84909C8.51993 25.9793 7.38409 25.8706 6.34493 25.6289C6.01868 25.5564 5.7649 25.3147 5.68032 25.0006C5.58365 24.6864 5.68033 24.3481 5.90991 24.1064L15.2504 14.766C15.6008 14.4156 16.1808 14.4156 16.5312 14.766L24.2404 22.4752C24.4095 22.6443 24.5062 22.8739 24.5062 23.1156C24.5062 23.3572 24.4095 23.5868 24.2404 23.756C22.7058 25.2785 20.4462 25.9793 17.0991 25.9793ZM8.45951 24.1185C8.89451 24.1547 9.35368 24.1668 9.84909 24.1668H17.0991C19.4191 24.1668 21.0745 23.8043 22.2466 23.0431L15.8908 16.6872L8.45951 24.1185Z"
//       fill="currentColor"
//     />
//   </svg>
// );

// const profile = (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     width="26"
//     height="26"
//     viewBox="0 0 28 27"
//     fill="none"
//   >
//     <path
//       fillRule="evenodd"
//       clipRule="evenodd"
//       d="M14.2003 2.71387C10.6417 2.71387 7.75684 5.59875 7.75684 9.15742C7.75684 12.7161 10.6417 15.601 14.2003 15.601C17.7591 15.601 20.6439 12.7161 20.6439 9.15742C20.6439 5.59875 17.7591 2.71387 14.2003 2.71387ZM9.79164 9.15742C9.79164 6.72254 11.7655 4.74867 14.2003 4.74867C16.6353 4.74867 18.6091 6.72254 18.6091 9.15742C18.6091 11.5923 16.6353 13.5662 14.2003 13.5662C11.7655 13.5662 9.79164 11.5923 9.79164 9.15742Z"
//       fill="currentColor"
//     />
//     <path
//       fillRule="evenodd"
//       clipRule="evenodd"
//       d="M20.2558 0.167842C18.7064 -2.0123e-05 16.7535 -1.06781e-05 14.2622 1.74239e-07H14.1395C11.6481 -1.06781e-05 9.69526 -2.0123e-05 8.1459 0.167842C6.56482 0.339143 5.28373 0.694991 4.18992 1.48969C3.52774 1.97079 2.9454 2.55312 2.46429 3.21531C1.66959 4.30912 1.31375 5.5902 1.14245 7.1713C0.974589 8.72064 0.974597 10.6735 0.97461 13.1648V13.2876C0.974597 15.779 0.974589 17.7319 1.14245 19.2812C1.31375 20.8622 1.66959 22.1433 2.46429 23.2371C2.92351 23.8692 3.47494 24.4285 4.10002 24.8965C4.12981 24.9188 4.15977 24.9409 4.18992 24.9627C5.28373 25.7575 6.56482 26.1134 8.1459 26.2847C9.69523 26.4525 11.6481 26.4525 14.1393 26.4525H14.2622C16.7535 26.4525 18.7064 26.4525 20.2558 26.2847C21.8369 26.1134 23.118 25.7575 24.2118 24.9627C24.2157 24.9599 24.2198 24.9569 24.2237 24.9541C24.2516 24.9337 24.2795 24.9132 24.307 24.8925C24.9299 24.4253 25.4794 23.8673 25.9374 23.2371C26.7321 22.1433 27.0879 20.8622 27.2592 19.2812C27.4272 17.7319 27.427 15.779 27.427 13.2877V13.1648C27.427 10.6736 27.4272 8.72063 27.2592 7.1713C27.0879 5.5902 26.7321 4.30912 25.9374 3.21531C25.4563 2.55312 24.8739 1.97079 24.2118 1.48969C23.118 0.694991 21.8369 0.339143 20.2558 0.167842ZM5.38595 3.13588C6.07507 2.63519 6.95712 2.34335 8.36508 2.1908C9.79209 2.0362 11.6349 2.0348 14.2008 2.0348C16.7668 2.0348 18.6095 2.0362 20.0366 2.1908C21.4446 2.34335 22.3266 2.63519 23.0157 3.13588C23.5051 3.49148 23.9356 3.92189 24.2913 4.41135C24.7918 5.10047 25.0837 5.98251 25.2362 7.39048C25.3909 8.81749 25.3922 10.6602 25.3922 13.2263C25.3922 15.7923 25.3909 17.635 25.2362 19.0619C25.0903 20.4095 24.8166 21.2754 24.3545 21.9514C23.4757 19.4377 21.0839 17.635 18.2704 17.635H10.1312C7.3179 17.635 4.92596 19.4377 4.04718 21.9514C3.58502 21.2754 3.31141 20.4095 3.16542 19.0619C3.01081 17.635 3.00942 15.7923 3.00942 13.2263C3.00942 10.6602 3.01081 8.81749 3.16542 7.39048C3.31796 5.98251 3.60981 5.10047 4.11049 4.41135C4.46608 3.92189 4.89651 3.49148 5.38595 3.13588ZM18.2704 19.6698C20.5274 19.6698 22.3889 21.3663 22.6482 23.5529C22.0135 23.912 21.2066 24.1349 20.0366 24.2617C18.6095 24.4163 16.7668 24.4177 14.2008 24.4177C11.6349 24.4177 9.79209 24.4163 8.36508 24.2617C7.19504 24.1349 6.3882 23.912 5.75343 23.5529C6.01301 21.3662 7.87426 19.6698 10.1312 19.6698H18.2704Z"
//       fill="currentColor"
//     />
//   </svg>
// );

const shop = (
  <svg
    width="26"
    height="26"
    viewBox="0 0 41 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M38.9919 12.0568C38.7398 9.71345 38.2058 7.81502 37.0341 6.1984C36.3222 5.21952 35.4472 4.3593 34.4683 3.64739C32.8517 2.46087 30.9532 1.94177 28.595 1.68963C26.311 1.4375 23.404 1.4375 19.711 1.4375H19.533C15.84 1.4375 12.933 1.4375 10.6342 1.68963C8.29078 1.94177 6.39236 2.46087 4.77573 3.64739C3.79685 4.3593 2.9218 5.21952 2.20989 6.1984C1.0382 7.81502 0.504269 9.71345 0.252135 12.0568C0 14.326 0 17.1737 0 20.8074V21.193C0 24.8267 0 27.6743 0.252135 29.9436C0.504269 32.2869 1.0382 34.1853 2.20989 35.802C2.9218 36.7808 3.79685 37.6411 4.77573 38.353C6.39236 39.5395 8.29078 40.0586 10.649 40.3107C12.933 40.5629 15.84 40.5629 19.533 40.5629H19.711C23.404 40.5629 26.311 40.5629 28.6099 40.3107C30.9532 40.0586 32.8517 39.5395 34.4683 38.353C35.4472 37.6411 36.3222 36.7808 37.0341 35.802C38.2058 34.1705 38.7398 32.2721 38.9919 29.9436C39.244 27.6743 39.244 24.8267 39.244 21.193V20.8074C39.244 17.1737 39.244 14.326 38.9919 12.0568ZM35.9959 29.6173C35.7586 31.7085 35.3285 33.0137 34.5869 34.037C34.0678 34.7638 33.4153 35.4015 32.7034 35.9206C31.68 36.677 30.36 37.1071 28.2836 37.3296C26.1627 37.5521 23.4337 37.5669 19.622 37.5669C15.8103 37.5669 13.0813 37.5669 10.9604 37.3296C8.88404 37.1071 7.56404 36.677 6.5555 35.9206C5.82876 35.4015 5.19101 34.7638 4.65708 34.037C3.9155 33.0137 3.48539 31.7085 3.24809 29.6173C3.02562 27.5409 3.02562 24.886 3.02562 21.193V20.8074C3.02562 17.1143 3.02562 14.4595 3.24809 12.3831C3.48539 10.2919 3.9155 8.98671 4.65708 7.96334C5.17618 7.2366 5.82876 6.59885 6.54067 6.07974C7.56404 5.32334 8.88404 4.89323 10.9604 4.67076C13.0813 4.44828 15.8103 4.43345 19.622 4.43345C23.4337 4.43345 26.1627 4.43345 28.2836 4.67076C30.36 4.89323 31.68 5.32334 32.6885 6.07974C33.4153 6.59885 34.053 7.2366 34.5869 7.96334C35.3285 8.98671 35.7586 10.2919 35.9959 12.3831C36.2184 14.4595 36.2184 17.1143 36.2184 20.8074V21.193C36.2184 24.886 36.2184 27.5409 35.9959 29.6173Z"
      fill="currentColor"
    />
    <path
      d="M17.3396 29.5375C17.3396 30.4147 16.6302 31.1255 15.7547 31.1255C14.8793 31.1255 14.1699 30.4147 14.1699 29.5375C14.1699 28.6603 14.8793 27.9495 15.7547 27.9495C16.6302 27.9495 17.3396 28.6603 17.3396 29.5375ZM23.6639 27.9495C22.7885 27.9495 22.0791 28.6603 22.0791 29.5375C22.0791 30.4147 22.7885 31.1255 23.6639 31.1255C24.5394 31.1255 25.2488 30.4147 25.2488 29.5375C25.2488 28.6603 24.5394 27.9495 23.6639 27.9495ZM26.4261 17.6501C27.9506 17.6501 29.1883 16.4099 29.1883 14.8824C29.1883 13.3549 27.9506 12.1147 26.4261 12.1147C24.9016 12.1147 23.6639 13.3549 23.6639 14.8824C23.6639 16.4099 24.9016 17.6501 26.4261 17.6501ZM25.8374 19.1927L24.5243 23.987H16.0717C15.8755 23.987 15.7095 23.8358 15.6793 23.6392L14.9849 18.4365H23.9356C23.1356 17.8618 22.5319 17.03 22.2451 16.0621H14.668L14.4567 14.5043C14.2755 13.128 13.0982 12.0996 11.7096 12.0996H10.2002V14.4741H11.7096C11.9058 14.4741 12.0718 14.6253 12.102 14.8219L13.3246 23.9568C13.5057 25.333 14.6831 26.3615 16.0717 26.3615H26.3204L28.4034 18.7541C27.8147 19.0566 27.1355 19.2381 26.4261 19.2381C26.2148 19.2381 26.0186 19.223 25.8223 19.1927H25.8374Z"
      fill="currentColor"
    />
  </svg>
);
